import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import NativeSelect from '@material-ui/core/NativeSelect';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from 'react-number-format';
import * as CashTeller from './Saga/CashTellers';
import jaLocale from "date-fns/locale/ja";
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { threadId } from 'worker_threads';
import format from "date-fns/format";
var moment = require('moment-timezone');

class ExtendedUtils extends DateFnsUtils {
    getCalendarHeaderText(date: any) {
        return format(date, "yyyy MMM", { locale: this.locale });
    }
    getDatePickerHeaderText(date: any) {
        return format(date, "MMMd日", { locale: this.locale });
    }
}

interface Props {
    modalcontract: any,
    toggle: any,
    cash_tellers_contentslist: any,
    secion_id: any,
    cash_tellers_insert: any,
    user_id: any,
    GetList: any,
    selectedDate: any,
    users: any,

}
interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat | null) => void;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values: any) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix=""
        />
    );
}

interface State {
    refresh: boolean,
    selectedDate: Date,
    cash_teller_content_id: Number,
    transction_name: string,
    room_name: string,
    customer_name: string,
    remarks: string,
    payment: any,
    user: Number,
    amSectionId: Number
}

var test = [{
    test: "テスト"
},
{
    test: "テスト"
},
{
    test: "テスト"
}
]

var colum: any;
colum = [];
class Cashteller extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            refresh: false,
            selectedDate: new Date(),
            cash_teller_content_id: 1,
            transction_name: "",
            room_name: "",
            customer_name: "",
            remarks: "",
            payment: null,
            user: 0,
            amSectionId: 0
        }
        this.insert = this.insert.bind(this);
        this.date_change = this.date_change.bind(this);
        this.title_change = this.title_change.bind(this);
        this.tatemono_change = this.tatemono_change.bind(this);
        this.room_change = this.room_change.bind(this);
        this.customer_change = this.customer_change.bind(this);
        this.remarks_change = this.remarks_change.bind(this);
        this.payment_change = this.payment_change.bind(this);
        this.UserChange = this.UserChange.bind(this);

    }






    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));

        console.log(this.state.refresh);

        return
    }

    date_change = (date: any) => {
        this.setState({
            selectedDate: new Date(date),
        });
    };

    title_change(e: any) {
        this.setState({
            cash_teller_content_id: e.target.value,
        });
    }

    tatemono_change(e: any) {
        this.setState({
            transction_name: e.target.value,
        });
    }
    room_change(e: any) {
        this.setState({
            room_name: e.target.value,
        });
    }
    customer_change(e: any) {
        this.setState({
            customer_name: e.target.value,
        });
    }
    remarks_change(e: any) {
        this.setState({
            remarks: e.target.value,
        });
    }
    payment_change(e: any) {
        this.setState({
            payment: e.target.value,
        });
    }


    insert() {

        var datas1 = new Date(this.props.selectedDate);
        var datas2 = new Date(this.state.selectedDate);


        var date = datas1.getMonth();
        var date2 = datas2.getMonth();

        if (this.state.cash_teller_content_id == 30 && this.state.remarks == "") {
            alert("入力エラー。画面をよく見て下さい。")
            return
        }

        if (date != date2) {
            alert("選択している月が違います")
            return
        }

        if (this.state.payment == 0) {
            alert("金額が入力されていません")
            return
        }
        var d = moment(new Date()).tz("Asia/Tokyo").format('YYYY-MM-DD HH:mm:ss');

        var data = {
            transction_date: this.state.selectedDate,
            cash_teller_content_id: this.state.cash_teller_content_id,
            section_id: this.props.secion_id,
            transction_name: this.state.transction_name,
            room_name: this.state.room_name,
            customer_name: this.state.customer_name,
            remarks: this.state.remarks,
            payment: this.state.payment,
            created_user: this.props.user_id,
            created_at: d,
            payed_user_id: this.state.user,
            payed_section_id: this.state.amSectionId
        }

        console.log(data);
        this.props.cash_tellers_insert(data);
        alert("追加されました");
        this.props.GetList();
        // this.props.toggle();

        // this.setState({
        //     // selectedDate: new Date(),
        //     // cash_teller_content_id: 1,
        //     transction_name: "",
        //     room_name: "",
        //     customer_name: "",
        //     remarks: "",
        //     // payment: 0,
        // });
    }


    UserChange(event: any, values: any) {
        if (values) {
            console.log(values);
            this.setState({
                user: values.id,
                amSectionId: values.amSectionId
            });
        }
    }


    // // エンターキーが押された時に次の項目に飛ぶようにする
    // handleKeyDown(e: any) {
    //     if (e.keyCode === 13) {
    //         // エンターキーが押された時の処理
    //         alert("エンターを押した")
    //     }
    // }

    render() {

        return (
            <div>

                <Modal isOpen={this.props.modalcontract} toggle={this.props.toggle} size="lg" fade={false}>
                    <ModalHeader toggle={this.props.toggle}>
                        新規追加
                    </ModalHeader>
                    <ModalBody style={{ fontSize: "18px" }} >

                        {/* ユーザー選択 */}

                        <Autocomplete
                            id="combo-box-demo"
                            options={this.props.users}
                            getOptionLabel={(option: any) => option.userNameAll}
                            style={{ width: 300 }}
                            onChange={this.UserChange}
                            renderInput={(params) => <TextField {...params} label="社員選択" />}
                        />


                        {/* 日付選択 */}
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={jaLocale}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                margin="normal"
                                id="date-picker-dialog"
                                label="精算実行日"
                                format="yyyy/MM/dd"
                                value={this.state.selectedDate}
                                onChange={this.date_change}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </MuiPickersUtilsProvider>


                        <div style={{ paddingTop: "20px" }}>
                            <InputLabel htmlFor="age-native-helper">内容を選択</InputLabel>
                            <NativeSelect
                                style={{ fontSize: "20px" }}
                                onChange={this.title_change}
                                inputProps={{
                                    name: '店舗',
                                    id: 'uncontrolled-native',
                                }}
                            >



                                {/* センターと住研で表示する項目を分ける */}
                                {(() => {



                                    var i = 0;
                                    colum = [];

                                    if (this.props.secion_id == 102) {
                                        this.props.cash_tellers_contentslist.forEach((value: any) => {
                                            if (value.company == 2) {
                                                colum[i] = value;
                                                i++;
                                            }
                                        });
                                    } else if (this.props.secion_id == 20 || this.props.secion_id == 14) {
                                        this.props.cash_tellers_contentslist.forEach((value: any) => {
                                            if (value.company == 3) {
                                                colum[i] = value;
                                                i++;
                                            }
                                        });
                                    } else {
                                        this.props.cash_tellers_contentslist.forEach((value: any) => {
                                            if (value.company == 1) {
                                                colum[i] = value;
                                                i++;
                                            }
                                        });
                                    }

                                })()}


                                {colum.map((d: any) => (
                                    <option key={d.id} value={d.id}>
                                        {d.name}
                                    </option>
                                ))}


                            </NativeSelect>
                        </div>

                        <div style={{ paddingTop: "30px" }}>
                            <TextField id="standard-basic" value={this.state.transction_name} label="物件名・領収書枚数など" onChange={this.tatemono_change} />
                            <span style={{ paddingLeft: "30px" }} >
                                <TextField id="standard-basic" value={this.state.room_name} label="号室・区画を入力" onChange={this.room_change} />
                            </span>
                        </div>

                        <div style={{ paddingTop: "30px" }}>
                            <TextField value={this.state.customer_name} id="standard-basic" label="顧客名を入力" onChange={this.customer_change} />
                        </div>

                        <div style={{ paddingTop: "30px" }}>
                            <TextField value={this.state.remarks} id="bikou" label="備考" onChange={this.remarks_change} />
                            {this.state.cash_teller_content_id == 30 ?
                                <span style={{ fontSize: "18px", paddingLeft: "10px", color: "red", fontWeight: "bold" }}>
                                    ※何月分の家賃かを必ず入力して下さい!!
                                </span>
                                : ""}
                        </div>

                        <div style={{ paddingTop: "30px" }}>
                            <TextField
                                value={this.state.payment}
                                onChange={this.payment_change}
                                label="入出金"
                                name="numberformat"
                                id="formatted-numberformat-input"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                            />
                            <span style={{ fontSize: "18px", paddingLeft: "10px", color: "red", fontWeight: "bold" }}>
                                ※出金はマイナス表記
                            </span>
                        </div>





                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn btn-success item-outer col-lg-12" onClick={this.insert}>保存</button>
                    </ModalFooter>
                </Modal>
            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {
        shops: state.masterReducer.shops,
        users: state.masterReducer.users,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        cash_tellers_insert(state: any) {
            dispatch(CashTeller.cash_tellers_insert(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cashteller);




